// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'discussions'

/**
 * Discussion Model Interface (auto-generated from Drizzle schema)
 */
export interface DiscussionModel {
  id: string
  orgId: string
  workspaceId: string
  userId: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  entityType: string
  entityId: string
  content: string
  contentHtml?: string
  parentId: string
  threadDepth: number
  isEdited: boolean
  editedAt?: string
  isDeleted: boolean
  deletedAt?: string
  userName: string
  userAvatar?: string
  attachments?: Record<string, unknown>[]
  reactionCounts?: Record<string, unknown>
  mentions?: Record<string, unknown>[]
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "entityType": {
          "type": "string",
          "maxLength": 50
      },
      "entityId": {
          "type": "string",
          "maxLength": 100
      },
      "content": {
          "type": "string",
          "maxLength": 100000
      },
      "contentHtml": {
          "type": "string",
          "maxLength": 200
      },
      "parentId": {
          "type": "string",
          "maxLength": 100
      },
      "threadDepth": {
          "type": "integer"
      },
      "isEdited": {
          "type": "boolean"
      },
      "editedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "isDeleted": {
          "type": "boolean"
      },
      "deletedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "userName": {
          "type": "string",
          "maxLength": 200
      },
      "userAvatar": {
          "type": "string",
          "maxLength": 200
      },
      "attachments": {
          "type": "array",
          "items": {
              "type": "object",
              "properties": {
                  "id": {
                      "type": "string"
                  },
                  "name": {
                      "type": "string"
                  },
                  "size": {
                      "type": "number"
                  },
                  "type": {
                      "type": "string"
                  },
                  "url": {
                      "type": "string"
                  },
                  "uploadedAt": {
                      "type": "string",
                      "format": "date-time"
                  },
                  "status": {
                      "type": "string",
                      "enum": [
                          "pending",
                          "uploaded",
                          "failed"
                      ]
                  },
                  "thumbnailUrl": {
                      "type": "string"
                  },
                  "checksum": {
                      "type": "string"
                  }
              },
              "required": [
                  "id",
                  "name",
                  "size",
                  "type",
                  "url",
                  "uploadedAt",
                  "status"
              ]
          }
      },
      "reactionCounts": {
          "type": "object"
      },
      "mentions": {
          "type": "array",
          "items": {
              "type": "object",
              "properties": {
                  "type": {
                      "type": "string",
                      "maxLength": 50
                  },
                  "identifier": {
                      "type": "string",
                      "maxLength": 200
                  },
                  "teamMemberId": {
                      "type": "string",
                      "maxLength": 100
                  },
                  "userId": {
                      "type": "string",
                      "maxLength": 100
                  },
                  "position": {
                      "type": "integer",
                      "minimum": 0,
                      "maximum": 999999,
                      "multipleOf": 1
                  }
              },
              "required": [
                  "type",
                  "identifier",
                  "position"
              ]
          }
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "entityType",
      "entityId",
      "content",
      "threadDepth",
      "isEdited",
      "isDeleted",
      "userName",
      "parentId",
      "userId",
      "workspaceId"
  ],
  indexes: [
      [
          "orgId",
          "entityType",
          "entityId",
          "createdAt"
      ],
      [
          "parentId",
          "createdAt"
      ],
      [
          "userId",
          "createdAt"
      ],
      [
          "orgId",
          "createdAt"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "workspaceId",
          "createdAt"
      ],
      [
          "isDeleted",
          "createdAt"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
